import React from 'react';

export const Controller = ({
  min,
  max,
  step = 1,
  currentValue,
  onChange,
  showOutput,
}) => (
  <>
    <input
      id="sliderWithValue"
      style={{ margin: 0 }}
      className={`ml-1 mr-1 slider is-fullwidth ${
        showOutput ? 'has-output' : ''
      }`}
      step={step}
      min={min}
      max={max}
      value={currentValue}
      onChange={onChange}
      type="range"
    />
    {showOutput && (
      <output style={{ outerWidth: 100 }} htmlFor="sliderWithValue">
        {currentValue}
      </output>
    )}
  </>
);
